import { DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Inject, Input, NgModule } from '@angular/core';
import * as i21 from '@upr-web-primer/card-promotion';
import * as i3 from '@upr-web-primer/digital-data';
import * as i1 from '@upr-web-primer/gds-button-events';
import { GdsButtonEventsModule } from '@upr-web-primer/gds-button-events';
import * as i2 from '@upr-web-primer/gds-button-model-service';
import * as i20 from '@upr-web-primer/gds-calendar';
import { GdsCalendarModule } from '@upr-web-primer/gds-calendar';
import * as i18 from '@upr-web-primer/gds-common-utility';
import { GdsCommonUtilityModule } from '@upr-web-primer/gds-common-utility';
import * as i26 from '@upr-web-primer/gds-comparison-table';
import * as i4 from '@upr-web-primer/gds-data-model';
import * as i5 from '@upr-web-primer/gds-filter-list';
import { GdsFilterListService } from '@upr-web-primer/gds-filter-list';
import * as i24 from '@upr-web-primer/gds-input-form';
import * as i25 from '@upr-web-primer/gds-interactive-map';
import * as i19 from '@upr-web-primer/gds-loader';
import { GdsLoaderDirective } from '@upr-web-primer/gds-loader';
import * as i6 from '@upr-web-primer/gds-modal';
import * as i14 from '@upr-web-primer/gds-picture-model';
import * as i7 from '@upr-web-primer/gds-poi';
import * as i15 from '@upr-web-primer/gds-route-resolver';
import * as i16 from '@upr-web-primer/gds-state-service';
import * as i17 from '@upr-web-primer/gds-trip-advisor';
import { GdsTripAdvisorModule } from '@upr-web-primer/gds-trip-advisor';
import * as i8 from '@upr-web-primer/geolocation';
import * as i10 from '@upr-web-primer/locale';
import * as i9 from '@upr-web-primer/ms-guests';
import { MsGuestModule } from '@upr-web-primer/ms-guests';
import * as i13 from '@upr-web-primer/ms-personalization';
import { MsPersonalizationModule } from '@upr-web-primer/ms-personalization';
import * as i22 from '@upr-web-primer/notification';
import * as i12 from '@upr-web-primer/page-labels';
import { PageLabelsModule } from '@upr-web-primer/page-labels';
import * as i23 from '@upr-web-primer/spinner';
import * as i11 from '@upr-web-primer/storage';
import { StorageModule } from '@upr-web-primer/storage';
import { WINDOW } from '@upr-web-primer/window';
import { get, isArray } from 'lodash-es';
const _c0 = ["*"];
class GdsDynamicLoaderComponent extends GdsLoaderDirective {
  constructor(window, document, appDefaults, relativeUrls, defaultValues, buttonEventsService, buttonDataMapper, changeDetect, digitalDataService, element, gdsDataModelService, gdsFilterListService, gdsModalService, gdsPoiService, geoLocationService, guestService, localeService, localStorage, pageLabelsResolver, personalize, pictureService, renderer, routeResolver, state, tripAdvisor, utilities, viewContainerRef, xpmService, calendarEventService, calendarBlockoutDateService, cardPromotionService, notification, spinner, gdsInputFormService, gdsInteractiveMapService, gdsComparisonTableService) {
    super(window, document, appDefaults, relativeUrls, defaultValues, buttonEventsService, buttonDataMapper, changeDetect, digitalDataService, element, gdsDataModelService, gdsFilterListService, gdsModalService, gdsPoiService, geoLocationService, guestService, localeService, localStorage, pageLabelsResolver, personalize, pictureService, renderer, routeResolver, state, tripAdvisor, utilities, viewContainerRef, xpmService, calendarEventService, calendarBlockoutDateService, cardPromotionService, notification, spinner, gdsInputFormService, gdsInteractiveMapService, gdsComparisonTableService);
    /**
     * To determine which type of component's
     * content to load
     * @type string
     */
    this.contentType = 'dynamic';
  }
  ngOnInit() {
    this.loadGdsComponent(this.data);
  }
  /**
   * Loads the GDS component
   * @returns void
   * @memberof GdsDynamicLoaderComponent
   * @method loadGdsComponent
   * @private
   */
  loadGdsComponent(data) {
    const componentList = get(data, '[0].elements', []) || get(data, 'elements', []);
    if (!componentList.length) {
      return;
    }
    componentList.forEach((component, index) => {
      const componentName = get(component, 'componentTemplate.Meta.name', '');
      try {
        const componentAttrs = get(component, 'componentTemplate.Meta.attributes', '');
        let componentData = get(component, 'component[0]', '');
        if (!!componentData) {
          componentData = this.gdsDataModelService.parseContent(componentData);
        }
        const templateNameCheck = componentName.toLowerCase().startsWith('gds-');
        if (templateNameCheck) {
          let gdsComponent = this.document.createElement(componentName);
          for (const attr of componentAttrs) {
            gdsComponent.setAttribute(attr.key, attr.value);
          }
          gdsComponent = this.setComponentAttributes(componentData, gdsComponent, []);
          this.addListener(componentData, this.contentType);
          if (componentName.toLowerCase() === 'gds-cf3-input') {
            this.getCf3Input(componentData, gdsComponent);
            return;
          }
          if (componentName.toLowerCase() === 'gds-swimlane') {
            if (isArray(componentData?.items) && componentData?.items?.length > 0) {
              componentData = this.determineContent(gdsComponent, componentData, get(this.data, `0.elements[${index}]`, this.data), index);
              return;
            } else {
              ({
                gdsComponent,
                componentData
              } = this.resetToNull(gdsComponent, componentData));
            }
          }
          if (componentName.toLowerCase() === 'gds-article-detail') {
            if (componentData?.button?.length > 1 && componentData?.button.some(x => x.customEventDetail.length > 0)) {
              componentData.buttons = componentData.button;
              delete componentData['button'];
            }
          }
          if (componentName.toLowerCase() === 'gds-text-blocks') {
            this.renderTextBlocks(componentData, gdsComponent, componentData, component);
            return;
          }
          if (componentName.toLowerCase() === 'gds-comparison-table') {
            this.setComparisonTableData(componentData, gdsComponent);
            this.renderComponent(gdsComponent);
            return;
          }
          if (componentName.toLowerCase() === 'gds-blockout-date-calendar') {
            this.setBlockoutDateCalendarData(componentData, gdsComponent);
            this.renderComponent(gdsComponent);
            return;
          }
          this.setComponentData(gdsComponent, componentData);
          this.renderComponent(gdsComponent);
        }
      } catch (e) {
        console.error(`Failed to load ${componentName}.\n`, e);
      }
    });
  }
  /**
   * Reset the gdsComponent and componentData variables to null.
   * @param {any} gdsComponent - the component that is being rendered
   * @param {any} componentData - the data that will be passed to the component.
   * @returns The component and data that is being returned.
   */
  resetToNull(gdsComponent, componentData) {
    gdsComponent = '';
    componentData = '';
    return {
      gdsComponent,
      componentData
    };
  }
  static {
    this.ɵfac = function GdsDynamicLoaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsDynamicLoaderComponent)(i0.ɵɵdirectiveInject(WINDOW), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject('AppDefaults'), i0.ɵɵdirectiveInject('RelativeUrls'), i0.ɵɵdirectiveInject('DefaultValues'), i0.ɵɵdirectiveInject(i1.GdsButtonEventsService), i0.ɵɵdirectiveInject(i2.GdsButtonModelService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.DigitalDataService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i4.GdsDataModelService), i0.ɵɵdirectiveInject(i5.GdsFilterListService), i0.ɵɵdirectiveInject(i6.GdsModalService), i0.ɵɵdirectiveInject(i7.GdsPoiService), i0.ɵɵdirectiveInject(i8.GeolocationService), i0.ɵɵdirectiveInject(i9.MsGuestsService), i0.ɵɵdirectiveInject(i10.LocaleService), i0.ɵɵdirectiveInject(i11.LocalStorageService), i0.ɵɵdirectiveInject(i12.PageLabelsResolver), i0.ɵɵdirectiveInject(i13.MsPersonalizationService), i0.ɵɵdirectiveInject(i14.GdsPictureModelService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i15.GdsRouteResolverService), i0.ɵɵdirectiveInject(i16.GdsStateService), i0.ɵɵdirectiveInject(i17.GdsTripAdvisorService), i0.ɵɵdirectiveInject(i18.GdsCommonUtilityService), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i19.UprGdsXpmService), i0.ɵɵdirectiveInject(i20.GdsCalendarEventDayService), i0.ɵɵdirectiveInject(i20.GdsCalendarBlockoutDateService), i0.ɵɵdirectiveInject(i21.CardPromotionService), i0.ɵɵdirectiveInject(i22.NotificationService), i0.ɵɵdirectiveInject(i23.SpinnerService), i0.ɵɵdirectiveInject(i24.GdsInputFormService), i0.ɵɵdirectiveInject(i25.GdsInteractiveMapService), i0.ɵɵdirectiveInject(i26.GdsComparisonTableService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsDynamicLoaderComponent,
      selectors: [["upr-gds-dynamic"]],
      inputs: {
        data: "data"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([GdsFilterListService]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GdsDynamicLoaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsDynamicLoaderComponent, [{
    type: Component,
    args: [{
      selector: 'upr-gds-dynamic',
      template: ` <ng-content></ng-content> `,
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [GdsFilterListService],
      standalone: false
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppDefaults']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['RelativeUrls']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['DefaultValues']
    }]
  }, {
    type: i1.GdsButtonEventsService
  }, {
    type: i2.GdsButtonModelService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i3.DigitalDataService
  }, {
    type: i0.ElementRef
  }, {
    type: i4.GdsDataModelService
  }, {
    type: i5.GdsFilterListService
  }, {
    type: i6.GdsModalService
  }, {
    type: i7.GdsPoiService
  }, {
    type: i8.GeolocationService
  }, {
    type: i9.MsGuestsService
  }, {
    type: i10.LocaleService
  }, {
    type: i11.LocalStorageService
  }, {
    type: i12.PageLabelsResolver
  }, {
    type: i13.MsPersonalizationService
  }, {
    type: i14.GdsPictureModelService
  }, {
    type: i0.Renderer2
  }, {
    type: i15.GdsRouteResolverService
  }, {
    type: i16.GdsStateService
  }, {
    type: i17.GdsTripAdvisorService
  }, {
    type: i18.GdsCommonUtilityService
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i19.UprGdsXpmService
  }, {
    type: i20.GdsCalendarEventDayService
  }, {
    type: i20.GdsCalendarBlockoutDateService
  }, {
    type: i21.CardPromotionService
  }, {
    type: i22.NotificationService
  }, {
    type: i23.SpinnerService
  }, {
    type: i24.GdsInputFormService
  }, {
    type: i25.GdsInteractiveMapService
  }, {
    type: i26.GdsComparisonTableService
  }], {
    data: [{
      type: Input
    }]
  });
})();
class GdsDynamicLoaderModule {
  static {
    this.ɵfac = function GdsDynamicLoaderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsDynamicLoaderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsDynamicLoaderModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, PageLabelsModule, StorageModule, GdsButtonEventsModule, GdsCalendarModule, GdsCommonUtilityModule, GdsTripAdvisorModule, MsPersonalizationModule, MsGuestModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsDynamicLoaderModule, [{
    type: NgModule,
    args: [{
      declarations: [GdsDynamicLoaderComponent],
      imports: [CommonModule, PageLabelsModule, StorageModule, GdsButtonEventsModule, GdsCalendarModule, GdsCommonUtilityModule, GdsTripAdvisorModule, MsPersonalizationModule, MsGuestModule],
      exports: [GdsDynamicLoaderComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of gds-dynamic-loader
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsDynamicLoaderComponent, GdsDynamicLoaderModule };
